import React from 'react';
/**
 * ColumnArithmeticRenderer — Wrapper adapting ColumnArithmetic to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 *
 * The inner <ColumnArithmetic> already owns the rising-edge submit: it fires
 * onComplete(userInputs.join('')) exactly once when shouldValidate flips true.
 * We forward that straight to onAnswer. (Previously the wrapper ran a SECOND
 * edge detector over a buffered copy of the answer, which read the buffer one
 * tick too early — before the typed digits were stored — so an empty answer
 * always reached the validator and every answer was marked wrong.)
 */
import { QuestionRendererProps } from './types';
import { ColumnArithmetic } from '../ColumnArithmetic';
export function ColumnArithmeticRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  return <ColumnArithmetic question={question} onComplete={onAnswer} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-11407" data-mp="3izbp2phgm0tt" />;
}